const categoryId = window.categoryData;
const baseUrl = window.location.pathname;
const storeCurrencyGlobalSetting = '€';
const accountId = "shopify-51773669572";

const itemsPerPage = 48; 
let currentPage = 1;
let selectedFacets = getSelectedFacetsFromUrl();
let totalProducts = 0;
let isLoading = false;
let isBFCache = false;

// Listen for pageshow so we can detect if the page was restored from bfcache.
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    isBFCache = true;
  }
});

// Helper to detect iOS devices.
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

if (!isIOS()) {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  
  // Save scroll position when the page is hidden/unloaded.
  window.addEventListener('pagehide', function () {
    // Use the current pathname as part of the key to tie the scroll position to this page.
    const collectionKey = window.location.pathname;
    sessionStorage.setItem('collectionScrollPosition_' + collectionKey, window.scrollY);
  });
}

function updateURL(page, facets, sortOption) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('page', page);
    if (facets) {
      urlParams.set('facets', JSON.stringify(facets));
    } else {
      urlParams.delete('facets');
    }
    if (sortOption) {
      urlParams.set('sort', sortOption);
    } else {
      urlParams.delete('sort');
    }
    history.pushState(null, null, '?' + urlParams.toString());
  }
  
function getSelectedFacetsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const facetsParam = urlParams.get('facets');
    return facetsParam ? JSON.parse(facetsParam) : [];
  }

async function waitForNostojs() {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (typeof nostojs !== 'undefined') {
          clearInterval(interval);
          resolve();
        }
      }, 100); 
    });
}
  
async function fetchSearchSessionParams() {
    await waitForNostojs();
    return new Promise((resolve) => {
      nostojs(api => {
        api.getSearchSessionParams().then(response => {
          resolve(response);
        });
      });
    });
}

async function fetchProducts(page, facets, sortOption) {
    const from = (page - 1) * itemsPerPage;
    const facetsFilter = facets.length > 0 ? customStringify(facets) : '[]';
    let sortBy = [];
    switch (sortOption) {
      case 'price-high-to-low':
        sortBy.push({ field: 'price', order: 'desc' });
        break;
      case 'price-low-to-high':
        sortBy.push({ field: 'price', order: 'asc' });
        break;
      case 'new':
        sortBy.push({ field: 'datePublished', order: 'desc' });
        break;
      case 'popularity':
      default:
        sortBy.push({ field: 'popularity', order: 'desc' });
        break;
    }
    
    const sessionParams = await fetchSearchSessionParams();
    const sessionParamsString = JSON.stringify(sessionParams).replace(/"([^"]+)":/g, '$1:');
    
    const graphqlQuery = `
      query {
        search(
          accountId: "${accountId}",
          sessionParams: ${sessionParamsString},
          products: {
            categoryId: "${categoryId}",
            size: ${itemsPerPage},
            from: ${from},
            facets: ["*"],
            filter: ${facetsFilter},
            sort: ${customSortStringify(sortBy)}
          }
        ) {
          products {
            hits {
              productId
              categoryIds
              name
              datePublished
              url
              imageUrl
              alternateImageUrls
              price
              listPrice
              priceCurrencyCode
              reviewCount
              tags1
              customFields {
                key
                value
              }
              skus {
                name
                url
                availability
                id
                customFields{
                  key 
                  value
                }
              }
            }
            total
            size
            facets {
              ... on SearchTermsFacet {
                id
                field
                type
                name
                data {
                  value
                  count
                  selected
                }
              }
            }
          }
        }
      }
    `;
  
    const response = await fetch('https://search.nosto.com/v1/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query: graphqlQuery })
    });
    return response.json();
  }
 
async function renderProductsAndPagination(page, facets, sortOption) {
  if (isLoading) return;
  isLoading = true;

  let allProducts = [];
  let allFacets = [];
  const productGridContainer = document.getElementById('ProductGridContainer');

  // If the container is empty, assume an initial load (or a reset) and load pages 1 to current page.
  // Otherwise, if products are already rendered (e.g. when clicking "Show more"),
  // load only the new products.
  const loadAllPages = productGridContainer.innerHTML.trim() === '';
  

  if (loadAllPages) {
    // Loop through pages 1 up to the current page and combine the products.
    for (let i = 1; i <= page; i++) {
      const data = await fetchProducts(i, facets, sortOption);
      if (data.data && data.data.search && data.data.search.products) {
        const products = data.data.search.products.hits;
        totalProducts = data.data.search.products.total;
        allProducts = allProducts.concat(products);
        allFacets = data.data.search.products.facets;
      } else {
        console.log('Products data is not available in the response for page', i);
      }
    }
  } else {
    // Just fetch the current page (for "Show more" clicks)
    const data = await fetchProducts(page, facets, sortOption);
    if (data.data && data.data.search && data.data.search.products) {
      const products = data.data.search.products.hits;
      totalProducts = data.data.search.products.total;
      allProducts = products;
      allFacets = data.data.search.products.facets;
    } else {
      console.log('Products data is not available in the response.');
    }
  }

  // Track category page visit using recordSearch (this is done only for the current page's products)
  nostojs(api => {
    api.recordSearch(
      'category',
      {
        products: {
          categoryId: categoryId,
          filter: facets,
          sort: [{ field: sortOption }],
        }
      },
      {
        products: {
          hits: loadAllPages ? allProducts : allProducts,
          total: totalProducts,
          size: itemsPerPage,
          from: (page - 1) * itemsPerPage,
          categoryId: categoryId
        }
      }
    );
  });

if (facets && facets.length > 0) {
  // Look for the facet with field "skus.customFields.size"
  const sizeFacet = facets.find(facet => facet.field === 'skus.customFields.size');
  if (sizeFacet && sizeFacet.value && sizeFacet.value.length > 0) {
    const selectedSizes = sizeFacet.value;
    allProducts = allProducts.filter(product =>
      product.skus && product.skus.some(sku => {
        // Try to get the SKU's size from its customFields; fallback to sku.name if not found
        let skuSize = sku.name;
        if (sku.customFields && sku.customFields.length > 0) {
          const sizeField = sku.customFields.find(cf => cf.key === 'size');
          if (sizeField) {
            skuSize = sizeField.value;
          }
        }
        return selectedSizes.includes(skuSize) && sku.availability !== "OutOfStock";
      })
    );
  }
}


  
  // If we loaded all pages (e.g. on an initial load), clear and render them.
  // Otherwise, just append the newly fetched products.
  if (loadAllPages) {
    renderProducts(allProducts);
  } else {
    appendProducts(allProducts);
  }
  renderFacets(allFacets);
  updateProductCountText();
  updateProgressBar();
  hideLoadMoreButtonIfNecessary();

  attachEventListenersToButtons(); // Attach event listeners to the buttons

  updateSelectedFacetsDisplay(selectedFacets);
  hideLoader();
  isLoading = false;
  setTimeout(() => {
    initializeQuickShop();
  }, 700);
  
}

function appendProducts(products) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    products.forEach(product => {
      const productElement = createProductElement(product);
      productGridContainer.appendChild(productElement);
  
      // Attach event listener for product clicks
    productElement.querySelector('a').addEventListener('click', function() {
      nostojs(api => {
          api.recordSearchClick(
            'category',
            { productId: product.productId, url: product.url }
          );
      });
    });
  });
}
  
function updateProductCountText() {
  const showingCount = currentPage * itemsPerPage > totalProducts ? totalProducts : currentPage * itemsPerPage;
  document.getElementById('ProductCountText').innerText = `Showing ${showingCount} out of ${totalProducts} products`;
}
  
function updateProgressBar() {
  const progressPercentage = (currentPage * itemsPerPage / totalProducts) * 100;
  document.getElementById('ProgressBar').style.width = `${progressPercentage}%`;
}

function hideLoadMoreButtonIfNecessary() {
  const totalPages = Math.ceil(totalProducts / itemsPerPage);
  document.getElementById('LoadMoreButton').style.display = currentPage >= totalPages ? 'none' : 'block';
}
  
function attachEventListenersToFacets() {
    const facetContainers = document.querySelectorAll('.facet');
    facetContainers.forEach(container => {
      const facetValues = container.querySelectorAll('.facet-value-color, .facet-value');
      facetValues.forEach(valueElement => {
        valueElement.addEventListener('click', () => {
          valueElement.classList.toggle('selected');
          selectedFacets = collectSelectedFacets();
          updateURL(1, selectedFacets);
          currentPage = 1;
          document.getElementById('ProductGridContainer').innerHTML = ''; // Clear existing products
          renderProductsAndPagination(currentPage, selectedFacets);
          setTimeout(() => {
            console.log("facet-click");
            initializeQuickShop();
          }, 700);
        });
      });
    });
  }
    function reinitializeQuickShopSliders() {
    setTimeout(() => {
      const quickShopColorVariantSliders = document.querySelectorAll('.quickshop .product-single__color-variants');
      quickShopColorVariantSliders.forEach((slider) => {
        const colorVariantItems = slider.querySelectorAll('.quickshop .product-single__color-variant');
        if (colorVariantItems.length > 4) {
          const qsflickityInstance = Flickity.data(slider);
          if (qsflickityInstance) {
            qsflickityInstance.destroy();
          }
          new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            draggable: true,
          });
        }
      });

      const quickShopSlideshowSliders = document.querySelectorAll('.quickshop .product-slideshow');
      quickShopSlideshowSliders.forEach((slider) => {
        const qsmainflickityInstance = Flickity.data(slider);
        if (qsmainflickityInstance) {
          qsmainflickityInstance.destroy();
        }
        new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
        });
      });
    }, 300); 
  }

  function initializeQuickShop() {
    document.querySelectorAll('.mobile-atc-size-drawer').forEach(button => {
      button.addEventListener('pointerdown', async (event) => {
        event.preventDefault();
        
        const productHandle = button.getAttribute('data-product-handle');
        if (!productHandle) {
          console.error("Product handle not found.");
          return;
        }
        
        try {
          const response = await fetch(`/products/${productHandle}?view=ajax`);
          if (!response.ok) {
            throw new Error("Failed to fetch product page.");
          }
          
          const productHTML = await response.text();
          const ccartNostoCart = document.querySelector(".js-drawer-open-cart");
          const drawerContent = document.querySelector('.quickshop');
          if (drawerContent) {
            const headerHTML = `
               <div class="quickshop-header">
                    <div class="drawer__close">
                      <button type="button" class="drawer__close-button js-drawer-close">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="19.799" height="19.799" viewBox="0 0 19.799 19.799">
                          <g id="Group_4" data-name="Group 4" transform="translate(0.707 0.707)">
                            <line id="Line_1" data-name="Line 1" x2="26" transform="translate(0 0) rotate(45)" fill="none" stroke="#222" stroke-width="2"/>
                            <line id="Line_2" data-name="Line 2" x2="26" transform="translate(0 18.385) rotate(-45)" fill="none" stroke="#222" stroke-width="2"/>
                          </g>
                        </svg>
                        <span class="icon__fallback-text">{{ 'cart.general.close_cart' | t }}</span>
                      </button>
                    </div>
                    <div class="h1 site-header__logo" itemscope="" itemtype="http://schema.org/Organization">
                      <a href="/" itemprop="url" class="site-header__logo-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="98.439" height="26" viewBox="0 0 404.29 98.61"><polygon points="95.05 8.05 112.93 8.05 112.93 98.44 95.05 98.22 95.05 8.05" fill="currentColor"></polygon><path d="M336.18,243h17.93v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86s10.6-17.86,36.25-17.86c37.4,0,43.08,35.8,43.08,36.89v53.66H479l0-49.62s-.95-22.95-26-22.9c-24.85,0-27.52,22.9-27.52,22.9v49.61H407.67l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9l-.06,49.62H336.18Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M306.88,243l-.05,90.39h-18v-8s-13.35,9.15-26.26,8c-1.1-.11-43.47,1.11-44.35-47.13C218,245.49,258.12,243,258.12,243Zm-45.12,17.82s-25.49-2.35-25.71,25.51c1.8,29.34,26.81,28.7,26.81,28.7s22.95,1.9,25.91-21.78V260.86Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M501.08,243.1H519v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86a38.24,38.24,0,0,1,8.73,23.07c0,1.76,0,49.61,0,49.61H572.57l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9L519,333.48H501.08Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M495.61,235l-16.31,0,0,8.81a39.37,39.37,0,0,1,8.22,7.26c1.49,1.82,2.34,1.43,8.07,12.58Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M591.18,258.69c0-9.11,6.49-15.76,15.68-15.76s15.6,6.65,15.6,15.76-6.49,15.83-15.6,15.83S591.18,267.8,591.18,258.69Zm4.31,0c0,6.85,4.38,11.65,11.3,11.65s11.37-4.8,11.37-11.65S613.64,247,606.79,247,595.49,251.84,595.49,258.69Zm14.69,1.7,4.33,6.41-4.87.08-3.71-6.18h-1.31v6.18h-4v-16.6H608c3.47,0,5.79,2,5.79,5.17A4.92,4.92,0,0,1,610.18,260.39Zm-5.56-6.49v3.48h3.17a1.77,1.77,0,0,0,2-1.78c0-1.23-.93-1.7-2-1.7Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path></svg> 
                      </a>
                    </div>
                    <div class="drawer__empty-right"></div>
                </div>
            `;
            drawerContent.innerHTML = headerHTML + productHTML;
            yotpo.refreshWidgets();
            reinitializeQuickShopSliders();
           
            document.querySelectorAll('.size-selector-button').forEach(function(button) {

              button.addEventListener('click', function() {

                theme.SizeGuideModal.open();

              });

            });

            const closeButton = document.querySelector('.quickshop-header .drawer__close-button');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                const quickshop = document.querySelector('.quickshop');
                if (quickshop) {
                  quickshop.innerHTML = '';
                  quickshop.style.display = 'none';
                }
              });
            }
            drawerContent.style.display = 'flex';
            ccartNostoCart.click();
                // Add event listeners to variant input elements for selection logic
            document.querySelectorAll('.quickshop .variant-input').forEach(input => {
              input.addEventListener('click', () => {
                // Remove .var-inpt-selected from all other variant inputs within the quickshop container
                document.querySelectorAll('.quickshop .variant-input').forEach(el => {
                  el.classList.remove('var-inpt-selected');
                });
                // Add .var-inpt-selected to the clicked variant input
                input.classList.add('var-inpt-selected');
              });
            });
            
            // Add to cart logic
            document.querySelectorAll('.quickshop .product-single__form .add-to-cart').forEach(button => {
              button.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent default form submission
                
                const form = button.closest('.product-single__form');
                console.log(form);
            
                // Get the selected variant ID
                const selectedVariant = form.querySelector('.var-inpt-selected');
                if (!selectedVariant) {
                  console.error('No variant selected');
                  return;
                }
                const variantId = selectedVariant.getAttribute('data-variant-id');
                console.log(variantId);
            
                const ccart = document.querySelector(".js-drawer-open-cart");
            
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ id: variantId, quantity: 1 })
                })
                .then(response => response.json())
                .then(data => {
                  console.log('Added to cart');
                  document.dispatchEvent(new Event('cart:build'));
                  const quickshop = document.querySelector('.quickshop');
                  if (quickshop) {
                    quickshop.innerHTML = '';
                    quickshop.style.display = 'none';
                  }
                  setTimeout(() => {
    
                    nostojs(function(api) {
                      var request = api.createRecommendationRequest();
                      document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
                        request.addElements([element.id]); 
                      });
                      request.loadRecommendations();
                    });
    
                  }, 900); 
                })
                .catch(error => {
                  console.error('Error adding to cart:', error);
                });
              });
            });

              window._swat.fetch(function(r) {
      window.myWishList = r;

      if (window.myWishList.length > 0) {
        document.querySelector('.wishlist-link__bubble').classList.add('wishlist-link__bubble--visible');
      } else {
        document.querySelector('.wishlist-link__bubble').classList.remove('wishlist-link__bubble--visible');
      };

      
        const wishlistButtons = document.querySelectorAll('.wishlist');
        if (wishlistButtons.length == 0) return;

        wishlistButtons.forEach(function(button) {
          const empi = button.getAttribute('data-empi');
          const epi = button.getAttribute('data-epi');
          if (empi || epi) {
            const matching_arr = window.myWishList.filter(i => i.empi == empi || i.epi == epi);
            if (matching_arr.length == 0) return;
            button.classList.add('is-saved');
          }
        })
      
    });
            

 function attachAddToCartEvent() {
   console.log("what");
 // Remove the existing event listener to prevent multiple bindings
    const addToCartForm = document.querySelector('.quickshop .combined-product .product-form');
    const newAddToCartForm = addToCartForm.cloneNode(true);
    addToCartForm.parentNode.replaceChild(newAddToCartForm, addToCartForm);

    // Attach the new event listener for form submission
    newAddToCartForm.addEventListener('submit', function(event) {
      event.preventDefault(); // Prevent the default form submission behavior

      // Collect the form data
      const formData = new FormData(this);

      // Perform the AJAX request to add the product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest', // Ensure the request is recognized as AJAX
          'Accept': 'application/json' // Expect a JSON response from Shopify
        }
      })
      .then(response => {
        // Check if the response is OK, else throw an error
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        // Successfully added to cart, now open the cart drawer
        document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: data }})); // Dispatch a custom event to update the cart
        
        nostojs(function(api) {
          var request = api.createRecommendationRequest();
          document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
            request.addElements([element.id]); 
          });
          request.loadRecommendations();
        });
        
        const cartDrawer = document.querySelector('.js-drawer-open-cart');
        if (cartDrawer) {
          cartDrawer.click(); // Open the cart drawer if the element exists
        }
        const quickshop = document.querySelector('.quickshop');
                if (quickshop) {
                  quickshop.innerHTML = '';
                  quickshop.style.display = 'none';
                }
        cartDrawer.click();
      })
      .catch(error => {
        console.error('Error adding item to cart:', error);
      });
    });
  }
            
 function updateProductDetails(productUrl) {
    const newTitle = document.querySelector('.quickshop .product-single__title').textContent;
    document.title = newTitle;

    // Update the browser's URL
    // window.history.pushState({}, newTitle, productUrl);
   console.log("updateProductDetails");
    attachAddToCartEvent();
  }

 function onVariantChange({ target: optionValueElement }) {

  const productElement = document.querySelector('.quickshop .combined-product');
  const sectionId = document.querySelector('.quickshop #productSection').dataset.sectionId;
  const oldProductUrl = productElement.dataset.productUrl;
  const newProductUrl = optionValueElement.dataset.productUrl;
  const productUrl = newProductUrl ? newProductUrl : oldProductUrl;
  const newVariantId = optionValueElement.dataset.variantId;
  let params = `section_id=${sectionId}&`;
 

  if (newVariantId) {
    params += `variant=${newVariantId}`;
  } else {
    const selectedOptionValues = Array.from(document.querySelectorAll('.quickshop fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
    params += `option_values=${selectedOptionValues}`;
  }

  // Clear selected class from all radio buttons and their parent divs
  document.querySelectorAll('.quickshop variant-input').forEach(div => div.classList.remove('selected'));
  document.querySelectorAll('.quickshop input[type="radio"]').forEach(input => input.classList.remove('selected'));

  // Add selected class to the clicked radio button and its parent div
  optionValueElement.classList.add('selected');
  optionValueElement.closest('.variant-input').classList.add('selected');

  fetch(`${productUrl}?${params}`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      console.log(html);

      if (newProductUrl && oldProductUrl !== newProductUrl) {
        productElement.parentNode.insertBefore(html.querySelector('.combined-product'), productElement);
        productElement.remove();
     

        // Update the URL and title
        updateProductDetails(newProductUrl);
        reinitializeQuickShopSliders();
        yotpo.initWidgets();
        document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
          button.addEventListener('click', function() {
            theme.SizeGuideModal.open();
            console.log("im called");
          });
        });

        // Focus on the newly selected option
        document.querySelector(`#${optionValueElement.id}`).focus();

        // Reattach the event listeners for the updated product details
        console.log("this is called");
        attachAddToCartEvent();
        return;
      }

      // // Update option selectors
      document.querySelector('.quickshop .optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;

      // Focus on the newly selected option
      document.querySelector(`#${optionValueElement.id}`).focus();

      // Update the price if necessary
      const priceEl = document.querySelector('.quickshop .product__price');
      if (html.querySelector('.product__price')) {
        priceEl.innerHTML = html.querySelector('.product__price').innerHTML;
      } else {
        priceEl.innerHTML = '';
      }

        document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
          button.addEventListener('click', function() {
            theme.SizeGuideModal.open();
          });
        });
      
      // Update Add to Cart form with the correct variant ID
      const addToCartForm = document.querySelector('.quickshop .product-form');
      const newVariantInput = html.querySelector('.product-form input[name="id"]');
      addToCartForm.querySelector('.quickshop input[name="id"]').value = newVariantInput.value;
      
    });
   
    setTimeout(function() {
    const sectionIdYotpo = document.querySelector('.quickshop #productSection .combined-product').dataset.sectionId;
    var yotpoWidget = document.querySelector('.quickshop .new-pdp-info .yotpo-widget-instance');
          // Check if the widget exists
          if (yotpoWidget) {
            // Set your custom Yotpo product ID
    
            // Change the data-yotpo-product-id attribute
            yotpoWidget.setAttribute('data-yotpo-product-id', sectionIdYotpo);
            
            console.log('Yotpo product ID changed to:', sectionIdYotpo);
            yotpo.refreshWidgets();
          } else {
            console.error('Yotpo widget not found.');
          }
    
      }, 1500); 
    
        }
        const quickshopproductSection = document.querySelector('.quickshop #productSection');
        if (quickshopproductSection) {
            quickshopproductSection.addEventListener('change', onVariantChange);
        }

          console.log("aattaching");
          attachAddToCartEvent();
          }
        } catch (error) {
          
          console.error("Error loading product page:", error);
        }
      });
    });

  
}
function attachEventListenersToButtons() {
  document.querySelectorAll('.grid-product__action.wishlist').forEach(button => {
    button.addEventListener('click', handleWishListClick);
  });
  
  // document.querySelectorAll('.grid-product__action.add-to-cart').forEach(button => {
  //   button.addEventListener('click', handleAddToCartClick);
  // });

        document.querySelectorAll('.sku-item').forEach(item => {
          item.addEventListener('click', () => {
            const variantId = item.getAttribute('data-variant-id');
            const ccart = document.querySelector(".js-drawer-open-cart");
            
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(response => response.json())
            .then(data => {
              document.dispatchEvent(new Event('cart:build'));
              ccart.click();
              setTimeout(() => {
              nostojs(function(api) {
                var request = api.createRecommendationRequest();
                document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
                  request.addElements([element.id]); 
                });
                request.loadRecommendations();
              });
              }, 500);
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
            });
          });
        });




       // const nostoLoadedProducts = document.querySelectorAll('.product');
       //  nostoLoadedProducts.forEach(product => {
       //    const mobileAtcSizeDrawer = product.querySelector('.mobile-atc-size-drawer');
       //    const ccart = document.querySelector(".js-drawer-open-cart");
       //    if (!mobileAtcSizeDrawer) return;
       //    mobileAtcSizeDrawer.addEventListener('click', function(evt) {
       //      if (mobileAtcSizeDrawer.classList.contains('already-in-cart')) {
       //        ccart.click();
       //      }
       //      evt.stopPropagation();
       //      evt.preventDefault();
       //      // theme.SizeDrawer.open(evt, mobileAtcSizeDrawer.getAttribute('data-product-handle'));
       //    });
       //  });

  const tooltipbtns = document.querySelectorAll('.tooltip-btn');
  tooltipbtns.forEach(tooltip => {
        tooltip.addEventListener('click', function() {
            // Find the previous sibling with the class 'tooltip-content'
            let tooltipContent = this.previousElementSibling;

            tooltipContent.addEventListener('click', function() {
              tooltipContent.classList.remove('show');
              setTimeout(() => tooltipContent.style.display = 'none', 500);
            });
          
            if (tooltipContent.classList.contains('show')) {
                tooltipContent.classList.remove('show');
                setTimeout(() => {
                    tooltipContent.style.display = 'none';
                    tooltipContent.style.zIndex = '-1';
                }, 500); // Ensures fade effect completes
            } else {
                tooltipContent.style.display = 'flex';
                setTimeout(() => {
                    tooltipContent.classList.add('show');
                    tooltipContent.style.zIndex = '1';
                }, 10); // Timeout ensures smooth transition
            }

      });
  });
   // setTimeout(() => {
   //    // Select all elements with the class .nosto-product-images
   //    const nostoProductImages = document.querySelectorAll('.nosto-product-images');
      
   //    // Loop through each selected element and initialize Flickity
   //    nostoProductImages.forEach((element) => {
   //        new Flickity(element, {
   //            cellAlign: 'center',
   //            contain: true,
   //            draggable: true,
   //            wrapAround: true,
   //            pageDots: true,
   //            prevNextButtons: true,
   //            groupCells: 1
   //        });
   //    });
   //  }, 500);
}
  
function handleWishListClick(evt) {
  evt.stopPropagation();
  evt.preventDefault();
  const wishList = evt.target;
  const product = wishList.closest('.nosto-product-info');
  const wishlistbtn = wishList.closest('.wishlist');
  
  const wishListObject = {
    "epi": product.getAttribute('data-variant-id'),
    "du": product.getAttribute('data-product-url'),
    "empi": product.getAttribute('data-product-id'),
    "iu": product.getAttribute('data-product-image-url')
  };
  
  const isSaved = wishList.classList.toggle('is-saved');
  wishlistbtn.classList.toggle('is-saved');
  const action = isSaved ? 'addToWishList' : 'removeFromWishList';
  
  window._swat[action](wishListObject, function(r) {
    console.log('wishlist', isSaved ? 'added' : 'removed', r);
    // theme.updateWishList();
  });
}
  
// function handleAddToCartClick(evt) {
//   const addToCart = evt.currentTarget;
//   const product = addToCart.closest('.nosto-product-info');
//   const ccart = document.querySelector(".js-drawer-open-cart");
//   if (!addToCart) return;
    
//   evt.stopPropagation();
//   evt.preventDefault();
  
//   if (addToCart.classList.contains('already-in-cart')) {
//     ccart.click();
//   }
//   theme.SizeDrawer.open(evt, product.getAttribute('data-product-handle'));
  
// }
  
function collectSelectedFacets() {
  const selectedFacets = [];
  const facetContainers = document.querySelectorAll('.facet');
  facetContainers.forEach(container => {
    const facetName = container.querySelector('.facet-name').textContent.trim();
    const facetValues = container.querySelectorAll('.facet-value.selected, .facet-value-color.selected');
    if (facetValues.length > 0) {
      const field = container.querySelector('[id]').id;
      const values = Array.from(facetValues).map(valueElement =>
        valueElement.querySelector('a') ? valueElement.querySelector('a').title : valueElement.textContent.trim()
      );
      selectedFacets.push({ field, value: values });
    }
  });
  return selectedFacets;
}
  
function customStringify(obj) {
  if (Array.isArray(obj)) {
    return `[${obj.map(customStringify).join(',')}]`;
  } else if (typeof obj === 'object' && obj !== null) {
    const entries = Object.entries(obj).map(([key, value]) => `${key}:${customStringify(value)}`);
    return `{${entries.join(',')}}`;
  } else if (typeof obj === 'string') {
    return `"${obj}"`;
  } else {
    return String(obj);
  }
}

function customSortStringify(sortArray) {
  return '[' + sortArray.map(sortObj => `{field: "${sortObj.field}", order: ${sortObj.order}}`).join(', ') + ']';
}
  
function renderProducts(products) {
  const productGridContainer = document.getElementById('ProductGridContainer');
  productGridContainer.innerHTML = ''; 
  products.forEach(product => {
      const productElement = createProductElement(product);
      productGridContainer.appendChild(productElement);
  });
}
  
function createProductElement(product) {
  const productElement = document.createElement('div');
  productElement.classList.add('product');
  const productTitleCustom = product.url.split('/products/')[1];
  productElement.dataset.productHandle = productTitleCustom;
  const formattedPrice = product.price.toFixed(2);
  const formattedListPrice = product.listPrice.toFixed(2);

  const formattedFixedPrice = Number(product.price.toFixed(0));
  const formattedFixedListPrice = Number(product.listPrice.toFixed(0));

  const customBadgeField = product.customFields.find(field => field.key === 'custom-badges');
  let customBadges = customBadgeField ? customBadgeField.value : '';

          let lowest30dPriceAmount = null;
          
          if (product.skus && product.skus.length > 0) {
            const lowest30dPriceField = product.skus[0].customFields?.find(
              field => field.key === 'frykland_pricehistory-lowest'
            );
          
            if (lowest30dPriceField) {
              const lowest30dPrice = JSON.parse(lowest30dPriceField.value);
              lowest30dPriceAmount = parseFloat(lowest30dPrice.amount).toFixed(2);
            }
          }

  if (product.listPrice > product.price) {
    // 1 - SALE AUTO %
    // 2 - OUTLET
    const newValues = [
      'gid://shopify/Metaobject/123743338826',
      'gid://shopify/Metaobject/123743666506',
    ];
    customBadges = customBadges ? JSON.parse(customBadges) : [];
    customBadges = customBadges.concat(newValues);
  }

  if (Array.isArray(customBadges)) {
    customBadges = JSON.stringify(customBadges);
  }
  
 const excludeTags = Array.isArray(product.tags1)
  ? product.tags1.filter(tag => tag.startsWith('exclude_')).map(tag => tag.replace('exclude_', ''))
  : [];

  const hasBundleTag = Array.isArray(product.tags1) && product.tags1.includes('bundle');

    const wcategories = product?.categoryIds || [];
  const discountBoxes = document.querySelector('.logged-in-discounts-box-collection-page');
  
  let bestDiscount = null;
  
  if (Array.isArray(wcategories) && discountBoxes) {
    let i = 1;
  
    while (true) {
      const idsSpan = discountBoxes.querySelector(`.discount-ids-${i}`);
      const percentageSpan = discountBoxes.querySelector(`.discount-percentage-${i}`);
      const titleSpan = discountBoxes.querySelector(`.discount-title-${i}`);
  
      if (!idsSpan || !percentageSpan || !titleSpan) break; // no more groups
  
      const discountIds = idsSpan.innerText.split(',').map(id => id.trim());
      const matchFound = wcategories.some(catId => discountIds.includes(String(catId)));
  
      if (matchFound) {
        const percentage = parseFloat(percentageSpan.innerText.trim());
        if (!bestDiscount || percentage > bestDiscount.percentage) {
          bestDiscount = {
            discountIdGroup: i,
            percentage,
            title: titleSpan.innerText.trim(),
            ids: discountIds
          };
        }
      }
  
      i++;
    }
  }
  
  if (bestDiscount) {
    console.log("Best Discount Found:", bestDiscount);
    // Use: bestDiscount.percentage, bestDiscount.title, etc.
  }
  
    const discountHTML = bestDiscount
    ? `<div class="nosto-discount-banner"> ${bestDiscount.title} </div>`
    : '';
  
  const discountPercentage = bestDiscount?.percentage ?? 0;
  const discountedPriceLoggedIn = (product.price * discountPercentage) / 100;
  const newPriceLoggedInF = product.price - discountedPriceLoggedIn; 
  const newPriceLoggedIn = newPriceLoggedInF.toFixed(2);

  const reviewsRatingField = product.customFields.find(field => field.key === 'reviews-rating');
  const reviewsRating = reviewsRatingField ? JSON.parse(reviewsRatingField.value).value : null;
  
  const reviewsRatingCountField = product.customFields.find(field => field.key === 'reviews-rating_count');
  const reviewsRatingCount = reviewsRatingCountField ? reviewsRatingCountField.value : 0;
  
  const productColorVariantsField = product.customFields.find(field => field.key === 'product-color_variants');
  const productColorVariants = productColorVariantsField ? productColorVariantsField.value : '';
  const productColorVariantsCount = productColorVariants ? productColorVariants.split('|').length - 1 : 0;

  const alternateImageUrls = product.alternateImageUrls ? product.alternateImageUrls.slice(0, 1) : [];
  
 productElement.innerHTML = `
    <div class="search-result nosto-product-info product-bundle-${hasBundleTag}" data-product-handle="${productTitleCustom}" data-variant-id="${product.skus && product.skus[0] ? product.skus[0].id : ''}"  data-product-url="${product.url}" data-product-id="${product.productId}" data-product-image-url="${product.imageUrl}">
      <div class="top-container">
        <a class="nosto-product-images" href="${product.url}">
          <img src="${product.imageUrl}" alt="${product.name}" class="nosto-product-image">
          ${alternateImageUrls.map(url => `
            <img src="${url}" alt="${product.name}" class="nosto-product-image-secondary">
          `).join('')}
        </a>


          <div class="badges"></div>
          <p class="hide replace-badges">${customBadges}</p>
      
        <div class="wishlist-new-pdp">
          <button class="grid-product__action wishlist flip-animation" type="button" data-button-action="wishlist" data-empi="${product.productId}" data-with-epi="true" data-product-id="${product.productId}" data-variant-id="${product.skus && product.skus[0] ? product.skus[0].id : ''}"  data-product-url="${product.url}">
            <div class="front-side">
              <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
                <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
                  <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="none" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
              </svg>
              <span class="icon__fallback-text">Lisää toivelistalle</span>
            </div>
            <div class="back-side" aria-hidden="true">
              <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
                <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
                  <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
              </svg>

              <span class="icon__fallback-text">Poista toivelistalta</span>
            </div>
          </button>
        </div>
        
      </div>
      <div class="bottom-container">
        <a class="pdp-name-bottom-container" href="${product.url}">
          <span class="search-result__name">${product.name}</span>
        </a>
        <div class="nosto-bottom-bar">
          <div class="price-container-nosto-api ${discountHTML ? ' price-container-nosto-api-logged-in-discounts ' : ''}">

       ${bestDiscount
    ? ( hasBundleTag === false 
              ? (formattedFixedListPrice > formattedFixedPrice 
                  ? (lowest30dPriceAmount == null || lowest30dPriceAmount < 1
                      ? (formattedFixedListPrice > formattedFixedPrice  
                          ? `
                            <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${newPriceLoggedIn} ${storeCurrencyGlobalSetting}</span> 
                            <span class="search-result__price money grid-product__price price-compare-nosto" style="color: black;text-decoration: line-through;display:block;">${formattedListPrice} ${storeCurrencyGlobalSetting}</span>
                            <span class="sale-perc"></span>
                            
                            <div class="custom-tooltip-notice"> 
                             <div class="tooltip-content"> 
                                <p>  Yliviivattu = tuotteen alin hinta viimeisen 30 päivän aikana </p>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                             </div>
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info tooltip-btn" style="width: 15px;margin-right:5px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                            </div> ${discountHTML}` 
                         
                          : `
                            <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${newPriceLoggedIn} ${storeCurrencyGlobalSetting}</span> 
                            <span class="search-result__price money grid-product__price price-compare-nosto" style="color: black;text-decoration: line-through;display:block;">${formattedPrice} ${storeCurrencyGlobalSetting}</span>
                            ${discountHTML}`)
                      : lowest30dPriceAmount > formattedFixedPrice 
                        ? `
                          <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${newPriceLoggedIn} ${storeCurrencyGlobalSetting}</span> 
                          <span class="search-result__price money grid-product__price price-compare-nosto app-price" style="color: black;text-decoration: line-through;display:block;">${lowest30dPriceAmount}  ${storeCurrencyGlobalSetting}</span>
                          <span class="sale-perc"></span>
                          
                          <div class="custom-tooltip-notice"> 
                             <div class="tooltip-content"> 
                                <p>  Yliviivattu = tuotteen alin hinta viimeisen 30 päivän aikana </p>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                             </div>
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info tooltip-btn" style="width: 15px;margin-right:5px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                            </div> ${discountHTML}` 
                        : lowest30dPriceAmount <= formattedFixedPrice 
                          ? `<span class="search-result__price money grid-product__price price discounted-price-custom">${formattedPrice} ${storeCurrencyGlobalSetting}</span>${discountHTML}` 
                          : `<span>ERROR</span>`)
                  : ` <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${newPriceLoggedIn} ${storeCurrencyGlobalSetting}</span> 
                            <span class="search-result__price money grid-product__price price-compare-nosto" style="color: black;text-decoration: line-through;display:block;">${formattedPrice} ${storeCurrencyGlobalSetting}</span>
                            ${discountHTML}`) 
              : (formattedFixedListPrice > formattedFixedPrice 
                  ? `
                    <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${newPriceLoggedIn} ${storeCurrencyGlobalSetting}</span> 
                    <span class="search-result__price money grid-product__price price-compare-nosto" style="color: black;text-decoration: line-through;display:block;">${formattedListPrice} ${storeCurrencyGlobalSetting}</span>
                    <span class="sale-perc"></span> ${discountHTML}` 
                  : `
                    <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${newPriceLoggedIn} ${storeCurrencyGlobalSetting}</span> 
                    <span class="search-result__price money grid-product__price price-compare-nosto" style="color: black;text-decoration: line-through;display:block;">${formattedPrice} ${storeCurrencyGlobalSetting}</span>
                            ${discountHTML}`
                )
        )
  : ( hasBundleTag === false 
              ? (formattedFixedListPrice > formattedFixedPrice 
                  ? (lowest30dPriceAmount == null || lowest30dPriceAmount < 1
                      ? (formattedFixedListPrice > formattedFixedPrice  
                          ? `
                            <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${formattedPrice} ${storeCurrencyGlobalSetting}</span> 
                            <span class="search-result__price money grid-product__price price-compare-nosto" style="color: black;text-decoration: line-through;display:block;">${formattedListPrice} ${storeCurrencyGlobalSetting}</span>
                            <span class="sale-perc"></span>
                            <div class="custom-tooltip-notice"> 
                             <div class="tooltip-content"> 
                                <p> Yliviivattu = tuotteen alin hinta viimeisen 30 päivän aikana </p>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                             </div>
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info tooltip-btn" style="width: 15px;margin-right:5px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                            </div>` 
                          : `
                            <span class="search-result__price money grid-product__price price">${formattedPrice} ${storeCurrencyGlobalSetting}</span>`)
                      : lowest30dPriceAmount > formattedFixedPrice 
                        ? `
                          <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${formattedPrice} ${storeCurrencyGlobalSetting}</span> 
                          <span class="search-result__price money grid-product__price price-compare-nosto app-price" style="color: black;text-decoration: line-through;display:block;">${lowest30dPriceAmount}  ${storeCurrencyGlobalSetting}</span>
                          <span class="sale-perc"></span>
                          <div class="custom-tooltip-notice"> 
                             <div class="tooltip-content"> 
                                <p> Yliviivattu = tuotteen alin hinta viimeisen 30 päivän aikana </p>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                             </div>
                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info tooltip-btn" style="width: 15px;margin-right:5px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                            </div>` 
                        : lowest30dPriceAmount <= formattedFixedPrice 
                          ? `<span class="search-result__price money grid-product__price price discounted-price-custom ${formattedFixedListPrice} ${formattedFixedListPrice} ${lowest30dPriceAmount}">${formattedPrice} ${storeCurrencyGlobalSetting}</span>` 
                          : `<span>ERROR</span>`)
                  : `<span class="search-result__price money grid-product__price price">${formattedPrice} ${storeCurrencyGlobalSetting}</span>`) 
              : (formattedFixedListPrice > formattedFixedPrice 
                  ? `
                    <span class="search-result__price money grid-product__price price" style="color: #c1132c; font-weight: 500;">${formattedPrice} ${storeCurrencyGlobalSetting}</span> 
                    <span class="search-result__price money grid-product__price price-compare-nosto" style="color: black;text-decoration: line-through;display:block;">${formattedListPrice} ${storeCurrencyGlobalSetting}</span>
                    <span class="sale-perc"></span>` 
                  : `
                    <span class="search-result__price money grid-product__price price">${formattedPrice} ${storeCurrencyGlobalSetting}</span>`
                )
              )}
              
          </div>
          
          <div data-product-handle="${productTitleCustom}" class="mobile-atc-size-drawer" aria-label="Lisää ostoskoriin">
          <span>+</span>
          </div>
         
          

        </div>
        <div class="product-extra-data"> 
          <a href="${product.url}" style="${productColorVariantsCount > 0 ? '' : 'display:none;'} ">
            <span> Colors +${productColorVariantsCount}  
            </span>
          </a>
          <a href="${product.url}">
            <span style=" ${reviewsRating == null ? 'display:none;' : ''}"> ★ ${reviewsRating} (${reviewsRatingCount})  </span>
          </a>
        </div>
        
        <div class="sku-container-new">
          <span class="sku-new-add-to-cart-sign">Lisää ostoskoriin </span>
          <div class="sku-list-new">
   

            ${product.skus && product.skus.length > 0 
  ? product.skus.map(sku => `
      <div data-variant-id="${sku.id}" class="sku-item ${sku.availability === 'OutOfStock' ? 'unavailable' : ''}">
        <span class="sku-name">${sku.name}</span>
      </div>
    `).join('')
  : '<div class="no-skus">No variants available</div>'
}

          </div>
        </div>
        
      </div>
    </div>
  `;

  
    renderBadges(productElement, product, excludeTags);

if (window._swat && typeof window._swat.fetch === 'function') {
  window._swat.fetch(function (r) {
    window.myWishList = r;

    if (window.myWishList.length > 0) {
      document.querySelector('.wishlist-link__bubble').classList.add('wishlist-link__bubble--visible');
    } else {
      document.querySelector('.wishlist-link__bubble').classList.remove('wishlist-link__bubble--visible');
    }

    const wishlistButtons = document.querySelectorAll('.wishlist');
    if (wishlistButtons.length === 0) return;

    wishlistButtons.forEach(function (button) {
      const empi = button.getAttribute('data-empi');
      const epi = button.getAttribute('data-epi');
      if (empi || epi) {
        const matching_arr = window.myWishList.filter(i => i.empi === empi || i.epi === epi);
        if (matching_arr.length === 0) return;

        button.classList.add('is-saved');
      }
    });
  });
} else {
  console.warn("window._swat or its fetch method is not available. Skipping wishlist processing.");
}

  return productElement;
}

function renderFacets(facets) {
    const facetsContainer = document.getElementById('FacetsContainer');
    facetsContainer.innerHTML = ''; // Clear existing facets
    const filtersElement = document.createElement('div');
    const closeBtn = document.createElement('div');
    closeBtn.classList.add('close-button-facets');
    closeBtn.addEventListener('click', function () {
      facetsContainer.classList.remove('active');
    });
    filtersElement.classList.add('filters');
    filtersElement.innerHTML = 'Filters';
    facetsContainer.appendChild(filtersElement);
    facetsContainer.appendChild(closeBtn);
  
    facets.forEach(facet => {
      if (facet && Array.isArray(facet.data)) {
        const facetElement = createFacetElement(facet);
        facetsContainer.appendChild(facetElement);
      }
    });
  
    attachEventListenersToFacets();
    showFacets();
  }
  
function createFacetElement(facet) {
    const facetElement = document.createElement('div');
    facetElement.classList.add('facet');
    
    if (facet.name === "Värt") {
      facetElement.innerHTML = `                  
      <div class="${facet.name} Color" id="${facet.field}">
          <div class="facet-name">${facet.name}</div>
          <div class="facet-color-container">
            <div class="facet-values" aria-label="${facet.name}">
              ${facet.data.map(value => `
              <div class="facet-color-container">
                <div class="facet-value-color ${value.selected ? 'selected' : ''}">
                  <button class="${value.value}" title="${value.value}"></button>
                  <svg width="12" height="12" class="selected-color" xmlns="http://www.w3.org/2000/svg"><path d="M4.248 8.188L10.422 2l.826.826-7 7L1 6.578l.812-.826z" fill="currentColor" fill-rule="evenodd"></path></svg>
                </div>  
                <span class="facet-color-name" aria-label="${value.value}">${value.value}</span>
              </div>
              `).join('')}
            </div>
        </div> 
      `;
    } else if (facet.name === "Koko") {
      const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 34, 36, '36-38', 37, 38, 39, '39-41', 40, 41, 42, 44, '86/92', '98/104', '110/116', '122/128', '134/140', '146/152', 'XS/S', 'M/L', 'XL/XXL', 'M', 'M/L', 'L', 'XL', 'XXL', 'XXXL', 'One Size', 'Onesize', 'XL/XXL'];
      facet.data.sort((a, b) => {
        const indexA = sizeOrder.indexOf(a.value);
        const indexB = sizeOrder.indexOf(b.value);
      
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
    
        return indexA - indexB;
      });
      
      facetElement.innerHTML = `                  
      <div class="${facet.name}" id="${facet.field}">
        <div class="facet-name">${facet.name}</div>
        <div class="facet-values">
          ${facet.data.map(value => `
            <div data-color="${value.value}" class="facet-value ${value.selected ? 'selected' : ''}">
              ${value.value}
            </div>
          `).join('')}
        </div>
      </div>
    `;
    
    } else {
      facetElement.innerHTML = `                  
      <div class="${facet.name}" id="${facet.field}">
        <div class="facet-name">${facet.name}</div>
        <div class="facet-values">
          ${facet.data.map(value => `
            <div data-color="${value.value}" class="facet-value ${value.selected ? 'selected' : ''}">
              ${value.value}
            </div>
          `).join('')}
        </div>
      </div>
      `;
    }
    
    return facetElement;
  }
function renderBadges(productElement, product, excludeTags) {
  const badgesContainer = productElement.querySelector('.replace-badges');
  if (badgesContainer && badgesContainer.innerHTML.trim() !== "") {
    const badgesDiv = badgesContainer.previousElementSibling;
    if (badgesDiv) {
      const content = badgesContainer.textContent.trim();
      try {
        const parsedContent = JSON.parse(content);
        const storeBadges = document.querySelectorAll('.store-badges .badge');
        const badgeMap = {};
        
        // Create a map of store badges by their IDs
        storeBadges.forEach(badge => {
          const badgeId = badge.getAttribute('data-badge-id');
          badgeMap[badgeId] = badge.outerHTML;
        });

        // Render each badge based on parsed content
        parsedContent.forEach(id => {
          let newContent = badgeMap[id] || id;
          const newElement = document.createElement('div');
          const productContainer = badgesDiv.closest('.product');
          const percDiv = productContainer ? productContainer.querySelector('.bottom-container .sale-perc') : null;

let lowest30dPriceAmount = null;

if (product.skus && product.skus.length > 0) {
  const lowest30dPriceField = product.skus[0].customFields?.find(
    field => field.key === 'frykland_pricehistory-lowest'
  );

  if (lowest30dPriceField) {
 
    const lowest30dPrice = JSON.parse(lowest30dPriceField.value);
    lowest30dPriceAmount = parseFloat(lowest30dPrice.amount).toFixed(0);
  }
}

   

if (lowest30dPriceAmount != 0 && newContent.includes("% Sale auto")) {

  if (lowest30dPriceAmount > product.price) {
    const perc = ((lowest30dPriceAmount - product.price) / lowest30dPriceAmount) * 100;
    if (perc === 0) {
      newElement.style.display = 'none';
    } else {
      newContent = newContent.replace("% Sale auto", `-${perc.toFixed()}%`);
      percDiv.innerHTML = newContent;
      newElement.classList.add("hide");
    }
  } else if (lowest30dPriceAmount == null && product.listPrice > product.price) {
    const perc = ((product.listPrice - product.price) / product.listPrice) * 100;
    if (perc === 0) {
      newElement.style.display = 'none';
    } else {
      newContent = newContent.replace("% Sale auto", `-${perc.toFixed()}%`);
      percDiv.innerHTML = newContent;
      newElement.classList.add("hide");
    }
  } else {
    newElement.style.display = 'none';
  }
}


          newElement.innerHTML = newContent;

          const badgeIdNumericPart = id.split('/').pop();
          if (excludeTags.includes(badgeIdNumericPart)) {
            newElement.style.display = 'none';
          }

          badgesDiv.appendChild(newElement);

// Apply the z-index logic for each group of badges separately
const badges = badgesDiv.querySelectorAll('.badge');
const badgeGroups = {};

// Group badges by their class (e.g., q-1-p-1, q-1-p-2, etc.)
badges.forEach(badge => {
  // Extract the badge's specific group class
  const groupClass = Array.from(badge.classList).find(cls =>
    cls.match(/^q-\d+-p-\d+$/)
  );

  if (groupClass) {
    if (!badgeGroups[groupClass]) {
      badgeGroups[groupClass] = [];
    }
    badgeGroups[groupClass].push(badge);
  }
});

// Process each group separately
Object.keys(badgeGroups).forEach(groupClass => {
  const groupBadges = badgeGroups[groupClass];
  let maxZIndex = -Infinity;
  let topBadge = null;

  // Find the badge with the highest z-index in the group, excluding those in .hide divs
  groupBadges.forEach(badge => {
    if (!badge.closest('.hide')) {
      const zIndex = parseInt(badge.style.zIndex, 10) || 0;
      if (zIndex > maxZIndex) {
        maxZIndex = zIndex;
        topBadge = badge;
      }
    }
  });

  // Set opacity of all badges in the group to 0 except the top one
  groupBadges.forEach(badge => {
    if (!badge.closest('.hide') && badge !== topBadge) {
      badge.style.opacity = '0';
    } else {
      badge.style.opacity = '1'; // Ensure the top badge is visible
    }
  });
});

          
        });



      } catch (e) {
        console.error('Failed to parse content as JSON:', content);
      }
    }
  }
}


function showFacets(){
   const maxVisible = 9;
      const facetContainers = document.querySelectorAll('.facet-values');
      facetContainers.forEach(container => {
                  
        const facetValues = container.querySelectorAll('.facet-color-container, .facet-value');
        const moreLessButton = document.createElement('button');
        moreLessButton.classList.add('more-less-button');
        container.appendChild(moreLessButton);
    
        if (facetValues.length > maxVisible) {
            for (let i = maxVisible; i < facetValues.length; i++) {
                facetValues[i].classList.add('hidden');
            }
      
            moreLessButton.textContent = '+ More';
            moreLessButton.addEventListener('click', () => {
              const isHidden = facetValues[maxVisible].classList.contains('hidden');
              if (isHidden) {
                facetValues.forEach(item => item.classList.remove('hidden'));
                moreLessButton.textContent = '- Less';
              } else {
                  for (let i = maxVisible; i < facetValues.length; i++) {
                    facetValues[i].classList.add('hidden');
                  }
                  moreLessButton.textContent = '+ More';
                }
              });
              } else {
                moreLessButton.style.display = 'none';
              } 
          });
}

  const sarrowSVG = `<svg width="14" height="14" xmlns="http://www.w3.org/2000/svg"><path d="M10.056 9.944L7 6.872 3.944 9.944 3 9l4-4 4 4z" fill="currentColor" fill-rule="evenodd"></path></svg>`;
  function loadElements() {
    setTimeout(() => {
      document.querySelectorAll('.facet').forEach(facet => {
        const showfacetValues = facet.querySelector('.facet-values');
        const showdivs = showfacetValues.querySelectorAll('div');
        if (showdivs.length > 9) {
          for (let i = 9; i < showdivs.length; i++) {
            showdivs[i].classList.add('hidden');
          }
  
          const button = document.createElement('button');
          button.textContent = '+ More';
          button.classList.add('toggle-button');
          facet.appendChild(button);
  
          button.addEventListener('click', function () {
            const isExpanded = button.textContent === '+ More';
            for (let i = 9; i < showdivs.length; i++) {
              showdivs[i].classList.toggle('hidden', !isExpanded);
            }
            button.textContent = isExpanded ? '- Less' : '+ More';
          });
        }
  
        const facetName = facet.querySelector('.facet-name');
        facetName.insertAdjacentHTML('beforeend', sarrowSVG);
        facetName.addEventListener('click', () => {
          const isHidden = showfacetValues.style.display === 'none' || !showfacetValues.style.display;
          showfacetValues.style.display = isHidden ? 'flex' : 'none';
          facetName.classList.toggle('toggled', !isHidden);
        });
  
        function handleWishListClick(evt) {
          evt.stopPropagation();
          evt.preventDefault();
          const wishList = evt.target;
          const product = wishList.closest('.nosto-product-info');
          const wishlistbtn = wishList.closest('.wishlist');
  
          const wishListObject = {
            "epi": product.getAttribute('data-variant-id'),
            "du": product.getAttribute('data-product-url'),
            "empi": product.getAttribute('data-product-id'),
            "iu": product.getAttribute('data-product-image-url')
          };
  
          const isSaved = wishList.classList.toggle('is-saved');
          wishlistbtn.classList.toggle('is-saved');
          const action = isSaved ? 'addToWishList' : 'removeFromWishList';
  
          window._swat[action](wishListObject, function(r) {
            console.log('wishlist', isSaved ? 'added' : 'removed', r);
            // theme.updateWishList();
          });
        }

      });

    }, 300);
  };
  
  loadElements();
  
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  function updateSelectedFacetsDisplay(selectedFacets) {
    const filtersDiv = document.querySelector('.filters');
    if (!filtersDiv) return; 
  
    let selectedFacetsDiv = filtersDiv.querySelector('.selected-facets');
    if (!selectedFacetsDiv) {
      selectedFacetsDiv = document.createElement('div');
      selectedFacetsDiv.classList.add('selected-facets');
      filtersDiv.appendChild(selectedFacetsDiv);
    }
    selectedFacetsDiv.innerHTML = ''; 
  
    selectedFacets.forEach(facet => {
      facet.value.forEach(value => {
        const facetValue = document.createElement('span');
        facetValue.classList.add('facet-value-item');
        facetValue.textContent = value;
        const closeSvg = '<svg width="15" class="close-facet" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M11.865 4.27l-3.48 3.48 3.48 3.48-.885.885-3.48-3.48-3.48 3.48-.885-.885 3.48-3.48-3.48-3.48.885-.885 3.48 3.48 3.48-3.48z" fill="currentColor" fill-rule="evenodd"></path></svg>';
        facetValue.insertAdjacentHTML('beforeend', closeSvg);
        selectedFacetsDiv.appendChild(facetValue);
      });
    });
  
    attachEventListenersToCloseFacets(); 
  }
  
  function attachEventListenersToCloseFacets() {
    document.querySelectorAll('.close-facet').forEach(closeIcon => {
      closeIcon.addEventListener('click', function(event) {
        const facetValueItem = event.target.closest('.facet-value-item');
        const valueToRemove = facetValueItem.textContent.trim();
  
        selectedFacets = selectedFacets.map(facetGroup => ({
          field: facetGroup.field,
          value: facetGroup.value.filter(value => value !== valueToRemove)
        })).filter(facetGroup => facetGroup.value.length > 0); 
                                 
        updateURL(currentPage, selectedFacets);
        renderProductsAndPagination(currentPage, selectedFacets);
        updateSelectedFacetsDisplay(selectedFacets); 
        facetValueItem.remove(); 
      });
    });
  }
    
  // Function to show the loader
  function showLoader() {
    const loader = document.querySelector('.loader-container');
    const loaderBar = document.querySelector('.loader-bar');
    loader.style.display = 'flex'; // Show the loader

    // Gradually increase the width of the loader bar to simulate loading progress
    let progress = 0;
    const interval = setInterval(() => {
      if (progress >= 90) {
        clearInterval(interval);
      } else {
        progress += 5; // Increase by 2% every interval (this can be adjusted)
        loaderBar.style.width = progress + '%';
      }
    }, 100); // Update every 100ms
  }


 // Function to hide the loader after API response
function hideLoader() {
  const loader = document.querySelector('.loader-container');
  const loaderBar = document.querySelector('.loader-bar');

  if (!loader || !loaderBar) return; // Exit if elements don't exist

  // Hide the loader and reset the loader bar.
  loader.style.display = 'none';
  loaderBar.style.width = '0%';

  // If this is an iOS device and the page was restored from cache,
  // skip custom scroll restoration to allow native behavior.
  if (isIOS() && isBFCache) {
    return;
  }

  // Otherwise, restore the scroll position using saved value (if any)
  setTimeout(() => {
    requestAnimationFrame(() => {
      const collectionKey = window.location.pathname;
      const savedScroll = sessionStorage.getItem('collectionScrollPosition_' + collectionKey);
      if (savedScroll) {
        window.scrollTo({
          top: parseInt(savedScroll, 10),
          left: 0,
          behavior: 'smooth' // Change to 'auto' if smooth scrolling gives issues on some devices.
        });
        sessionStorage.removeItem('collectionScrollPosition_' + collectionKey);
      }
    });
  }, 50);
}


  document.addEventListener('DOMContentLoaded', function () {
    const facetsButton = document.querySelector('.facets-button');
    const facetsContainer = document.getElementById('FacetsContainer');
  
    facetsButton.addEventListener('click', function () {
      facetsContainer.classList.toggle('active');
    });
  
    document.addEventListener('click', function (event) {
      if (!facetsContainer.contains(event.target) && !facetsButton.contains(event.target)) {
        facetsContainer.classList.remove('active');
      }
    });
  });  
    
  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const page = parseInt(urlParams.get('page')) || 1;
    const sortOption = urlParams.get('sort') || 'popularity';
    currentPage = page;
    selectedFacets = getSelectedFacetsFromUrl();
    renderProductsAndPagination(page, selectedFacets, sortOption);
  
    document.getElementById('LoadMoreButton').addEventListener('click', function() {
      currentPage++;
      updateURL(currentPage, selectedFacets, sortOption);
      
      renderProductsAndPagination(currentPage, selectedFacets, sortOption);
    });
  
    attachEventListenersToFacets();
    document.getElementById('sort-options').addEventListener('change', function() {
      const newSortOption = this.value;
      updateURL(1, selectedFacets, newSortOption);
      currentPage = 1;
      document.getElementById('ProductGridContainer').innerHTML = '';
      renderProductsAndPagination(currentPage, selectedFacets, newSortOption);
      updateSelectedFacetsDisplay(selectedFacets); 
    });   
        //   document.querySelectorAll('.sku-item').forEach(item => {
        //   item.addEventListener('click', () => {
        //     const variantId = item.getAttribute('data-variant-id');
        //     const ccart = document.querySelector(".js-drawer-open-cart");
            
        //     fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json'
        //       },
        //       body: JSON.stringify({ id: variantId, quantity: 1 })
        //     })
        //     .then(response => response.json())
        //     .then(data => {
        //       document.dispatchEvent(new Event('cart:build'));
        //       ccart.click();
        //     })
        //     .catch(error => {
        //       console.error('Error adding to cart:', error);
        //     });
        //   });
        // });
   showLoader();
  });
  